import { IApplicationState } from '../../types/redux';

export const selectMarketTrandData = (state: IApplicationState) => state.marketTrand.marketTrendData;
